import React, { Fragment } from 'react';
import { Box, Button, Icon, Toolbar } from '@mui/material';
import { Colors } from '../../../utils/theme';
import { ChevronLeft } from '@mui/icons-material';

type IProps = {
  children: React.ReactNode;
  navName?: string;
  isManualStyles?: boolean;
  handleToOverview?: () => void;
};

const OverviewToolbar: React.FC<IProps> = (props: IProps) => {
  const { children, navName, handleToOverview, isManualStyles } = props;
  return (
    <Toolbar
      sx={{
        background: Colors.gradient,
        minHeight: '60px',
        padding: 0,
        zIndex: 2,
        position: 'relative',
        color: Colors.white
      }}
    >
      {handleToOverview && (
        <Button
          id={`to-${navName}-overview`}
          onClick={handleToOverview}
          sx={{ height: 60, width: 'auto', position: 'absolute', left: 0 }}
        >
          <ChevronLeft sx={{ color: Colors.white, marginRight: '4px' }} />
          <Box component="h3" sx={{ color: Colors.white }}>
            {navName}
          </Box>
        </Button>
      )}
      <Box
        // sx={isManualStyles ? { width: '100%', color: 'white' } : { margin: 'auto', color: 'white' }}
        sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
      >
        <Fragment>{children}</Fragment>
      </Box>
    </Toolbar>
  );
};

export default OverviewToolbar;
